import { SubjectEi, SubjectJi, SubjectKo, SubjectRi, SubjectSha, SubjectSu } from "../../../icons/index";
import { defaultTheme } from "../../../styles/defaultTheme";
import { assertNever } from "../../../utils/object-utils";
import { DrillType, DRILL_TYPE_INFORMATION, Subject } from "../constants/drill";
import { OVER_ELEMENTARY_BORDER_DRILL_TYPE } from "../constants/work-maker";
export var availableDrillTypeIdListFromSchool = function (schoolType) {
    var DrillTypeIdList = Object.values(DRILL_TYPE_INFORMATION).map(function (_a) {
        var id = _a.id;
        return id;
    });
    if (schoolType === 'COMPULSORY_EDUCATION_SCHOOL') {
        return DrillTypeIdList;
    }
    return DrillTypeIdList.filter(function (id) {
        return schoolType === 'ELEMENTARY_SCHOOL'
            ? id < OVER_ELEMENTARY_BORDER_DRILL_TYPE
            : id >= OVER_ELEMENTARY_BORDER_DRILL_TYPE;
    });
};
export var getDisplaySubjectInfoBySubjectId = function (grade, subjectId) {
    var subjectThemeObject = defaultTheme.palette.subjects;
    // 復習数学のみsubjectはCHUGAKU_SUGAKUだが教科は算数と表示する
    if (grade === 0 && subjectId === Subject.CHUGAKU_SUGAKU) {
        return { DisplayIcon: SubjectSu, displayValue: '算数', subjectTheme: subjectThemeObject.math };
    }
    switch (subjectId) {
        case Subject.KOKUGO:
        case Subject.CHUGAKU_KOKUGO:
            return { DisplayIcon: SubjectKo, displayValue: '国語', subjectTheme: subjectThemeObject.japanese };
        case Subject.SANSU:
            return { DisplayIcon: SubjectSu, displayValue: '算数', subjectTheme: subjectThemeObject.math };
        case Subject.CHUGAKU_SUGAKU:
            return { DisplayIcon: SubjectSu, displayValue: '数学', subjectTheme: subjectThemeObject.math };
        case Subject.RIKA:
        case Subject.CHUGAKU_RIKA:
            return { DisplayIcon: SubjectRi, displayValue: '理科', subjectTheme: subjectThemeObject.science };
        case Subject.SHAKAI:
        case Subject.CHUGAKU_SHAKAI:
            return { DisplayIcon: SubjectSha, displayValue: '社会', subjectTheme: subjectThemeObject.society };
        case Subject.EIGO:
        case Subject.CHUGAKU_ENDRILL:
            return { DisplayIcon: SubjectEi, displayValue: '英語', subjectTheme: subjectThemeObject.english };
        case Subject.CHUGAKU_JITSUGI:
            return {
                DisplayIcon: SubjectJi,
                displayValue: '実技',
                subjectTheme: subjectThemeObject.practicalSkills,
            };
        default:
            return assertNever(subjectId, '不明なsubjectIdが指定されました。');
    }
};
export var getDisplaySubjectInfoByDrillTypeId = function (grade, drillTypeId) {
    var subjectId = DRILL_TYPE_INFORMATION[drillTypeId].subjectId;
    return getDisplaySubjectInfoBySubjectId(grade, subjectId);
};
export var getDisplaySubjectInfoByDrillTypeName = function (grade, drillTypeName) {
    var drillTypeId = getDrillTypeIdFromName(drillTypeName);
    if (!drillTypeId)
        return undefined;
    return getDisplaySubjectInfoByDrillTypeId(grade, drillTypeId);
};
export function isDrillTypeId(value) {
    if (typeof value !== 'number')
        return false;
    return Object.values(DrillType).some(function (drillTypeId) { return drillTypeId === value; });
}
export function getDrillTypeNameFromId(drillTypeId) {
    return DRILL_TYPE_INFORMATION[drillTypeId].name;
}
function getDrillTypeIdFromName(drillTypeName) {
    var _a;
    return (_a = Object.values(DRILL_TYPE_INFORMATION).find(function (drillTypeInfo) { return drillTypeInfo.name === drillTypeName; })) === null || _a === void 0 ? void 0 : _a.id;
}
